import { useState, useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import RiftChessModal from './RiftChessModal'
import './AuthPage.css'

export default function AuthPage() {
  const [showModal, setShowModal] = useState(false)
  const [guestLoading, setGuestLoading] = useState(false)

  const { signInAsGuest, showRegister, setShowRegister } = useAuth()
  const [isLogin, setIsLogin] = useState(!showRegister)

  useEffect(() => {
    if (showRegister) {
      setIsLogin(false)
      setShowRegister(false) // Reset after using it
    }
  }, [showRegister, setShowRegister])

  const toggleMode = () => {
    setIsLogin(!isLogin)
  }

  const handleGuestLogin = async () => {
    setGuestLoading(true)
    try {
      await signInAsGuest()
    } catch (error) {
      console.error('Guest login failed:', error)
    } finally {
      setGuestLoading(false)
    }
  }

  const openModal = () => {
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-logo">
          <img
            src="/images/logo/finallogosquare.png"
            alt="RiftChess"
            className="auth-logo-icon"
          />
        </div>
        {isLogin ? (
          <>
            <LoginForm onToggleMode={toggleMode} />
            <div className="guest-login-section">
              <div className="divider">
                <span>OR</span>
              </div>
              <button className="guest-login-btn" onClick={handleGuestLogin} disabled={guestLoading}>
                {guestLoading ? 'Loading...' : 'Play as Guest'}
              </button>
              <p className="auth-info">
                New to RiftChess?{' '}
                <button className="link-button" onClick={openModal}>
                  Learn more
                </button>
              </p>
            </div>
          </>
        ) : (
          <RegisterForm onToggleMode={toggleMode} />
        )}
      </div>
      <RiftChessModal isOpen={showModal} onClose={closeModal} />
    </div>
  )
}